import classNames from 'classnames';
import { DepartureOrArrival } from '@shared/models/departureOrArrival';
import ImageIcon, { Icon } from '@shared/components/ImageIcon';
import { useDepartureDisplayTime } from '@shared/hooks/useDepartureOrArrivalDisplayTime';
import styles from './DepartureOrArrivalTableDepartureOrArrivalCell.module.scss';
import { DepartureOrArrivalTimeFormat } from '@shared/models/departureOrArrivalTimeFormat';

interface DepartureOrArrivalTableDepartureCellProps {
  departureOrArrival: DepartureOrArrival | undefined;
  format: DepartureOrArrivalTimeFormat;
  headerWidth?: number;
}

export default function DepartureOrArrivalTableDepartureCell({
  departureOrArrival,
  format,
  headerWidth,
}: DepartureOrArrivalTableDepartureCellProps) {
  const departureDisplayTime = useDepartureDisplayTime(
    departureOrArrival,
    format,
  );
  const hasCancelledDisplayTime = departureDisplayTime === 'Inställd';

  const trafficSituationIconType: Icon | undefined =
    departureOrArrival?.trafficSituationSeverity
      ? `traffic-situation-${departureOrArrival.trafficSituationSeverity}`
      : undefined;

  const renderWheelchairAccessible =
    format === 'countdown' &&
    !hasCancelledDisplayTime &&
    departureOrArrival?.isWheelchairAccessible;

  return (
    <td
      className={classNames(
        styles['departure-or-arrival'],
        hasCancelledDisplayTime && styles['departure-or-arrival--cancelled'],
      )}
      style={{ minWidth: headerWidth }}
    >
      <div
        className={classNames(
          styles['information'],
          format === 'countdown' && styles['information--countdown'],
        )}
      >
        {format === 'countdown' && trafficSituationIconType && (
          <ImageIcon
            type={trafficSituationIconType}
            alt="Avgången har ett störningsmeddelande"
            className={styles['connected-traffic-situation']}
          ></ImageIcon>
        )}
        {renderWheelchairAccessible && (
          <ImageIcon
            type="wheelchair-accessible"
            alt="Resan är anpassad för rullstol"
            className={styles['wheelchair-accessible']}
          ></ImageIcon>
        )}
        {departureDisplayTime &&
          format === 'countdown' &&
          !hasCancelledDisplayTime && (
            <span role="timer" className={styles['information__text']}>
              {departureDisplayTime}
            </span>
          )}
        {departureDisplayTime &&
          format === 'time' &&
          !hasCancelledDisplayTime && (
            <time
              className={classNames(
                styles['information__text'],
                styles['information__text--has-changed-clock-time'],
              )}
            >
              {departureDisplayTime}
            </time>
          )}
        {departureDisplayTime && hasCancelledDisplayTime && (
          <span className={styles['information__text']}>
            {departureDisplayTime}
          </span>
        )}
      </div>
    </td>
  );
}
